import React, { useEffect, useState } from "react";
import Header from "../Components/Header";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import "bootstrap-icons/font/bootstrap-icons.css";


const Products = () => {
  const [filteredBrands, setFilteredBrands] = useState([]);
  const [brands, setBrands] = useState([]);
  const [categorie, setcategorie] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  // const uniqueBrands = [...new Set(response.data.body.map(p => p.brand_name))];
  // setBrands(uniqueBrands);

  // const { category_id, subcategory_id } = useParams();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  // const [categories, setCategories] = useState([]);
  const [updateSuccess, setUpdateSuccess] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedproductId, setSelectedProductId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 25;
  const totalRecords = products.length;
  const totalPages = Math.ceil(totalRecords / recordsPerPage);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredproducts, setFilteredProducts] = useState("");
  // Calculate records for the current page
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredproducts.slice(indexOfFirstRecord, indexOfLastRecord);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  // Function to change the page
  const paginate = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  //console.log(searchQuery)


  const openDeleteModal = (product_id) => {
    setSelectedProductId(product_id);
    setShowModal(true);
  };
  const closeModal = () => {
    setSelectedProductId(null);
    setShowModal(false);
  };

  useEffect(() => {
    setLoading(true);

    Promise.all([
      axios.post(`${API_BASE_URL}product_list.php`, {}),
      axios.post(`${API_BASE_URL}brand_list.php`, {}),
      axios.post(`${API_BASE_URL}category_list.php`, {})
    ])
      .then(([productRes, brandRes, categoryRes]) => {
        // ✅ Products
        if (productRes.data?.head?.code === 200) {
          const productData = Array.isArray(productRes.data.body)
            ? productRes.data.body
            : [];

          setProducts(productData);
          setFilteredProducts(productData);
        } else {
          setProducts([]);
          setFilteredProducts([]);
        }

        // ✅ Brands
        if (brandRes.data?.head?.code === 200) {
          setBrands(Array.isArray(brandRes.data.body) ? brandRes.data.body : []);
          setFilteredBrands(brandRes.data.body || []);
        } else {
          setBrands([]);
        }

        // ✅ Category
        if (categoryRes.data?.head?.code === 200) {
          setcategorie(Array.isArray(categoryRes.data.body) ? categoryRes.data.body : []);
        } else {
          setcategorie([]);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        setProducts([]);
        setFilteredProducts([]);
        setBrands([]);
        setcategorie([]);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);


  const handleChange = (product_id, field, value) => {
    setProducts((prevProducts) =>
      prevProducts.map((product) =>
        product.product_id === product_id
          ? { ...product, [field]: value }
          : product
      )
    );
  };

  const handleDelete = async () => {
    if (!selectedproductId) return;

    try {
      const response = await axios.post(
        `${API_BASE_URL}product_list_delete.php`,
        {
          product_id: selectedproductId,
        }
      );
      if (response.data.head.code === 200) {
        alert("Product Deleted Successfully");
        closeModal();
        window.location.reload();
      } else {
        alert(response.head?.msg || "Failed To Delete Subcategory");
      }
    } catch (error) {
      console.error("Error Deleting Category", error);
    }
  };
  const handleBrandFilter = (brand) => {
    setSelectedBrand(brand);

    let filtered = products;

    // 🔹 Brand filter
    if (brand) {
      filtered = filtered.filter(p => p.brand_name === brand);
    }

    // 🔹 Search filter also apply
    if (searchQuery) {
      filtered = filtered.filter(item =>
        item.product_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.product_code?.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    setFilteredProducts(filtered);
    setCurrentPage(1);
  };
  const handleCategoryFilter = (category) => {
  setSelectedCategory(category);

  // ✅ FILTER PRODUCTS (your existing logic)
  let filtered = products;

  if (category) {
    filtered = filtered.filter(p => p.category_name === category);
  }

  if (searchQuery) {
    filtered = filtered.filter(item =>
      item.product_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.product_code?.toLowerCase().includes(searchQuery.toLowerCase())
    );
  }

  setFilteredProducts(filtered);
  setCurrentPage(1);

  // ✅ FILTER BRANDS BASED ON CATEGORY
  if (category) {
    const filtered = brands.filter(
      b => b.type_of_category === category
    );
    setFilteredBrands(filtered);
  } else {
    // ✅ ALL CATEGORY → SHOW ALL BRANDS
    setFilteredBrands(brands);
  }

  // ✅ RESET BRAND SELECTION
  setSelectedBrand("");
};
  //   const handleSearch = (e) => {
  //     const query = e.target.value;
  //     setSearchQuery(query);

  //     console.log("Search Query:", query);
  //     console.log("Products:", products);

  //     if (!products || products.length === 0) {
  //       console.warn("No products available for searching.");
  //       return;
  //     }

  //     const searchedOrders = products.filter((item) => {
  //       return (
  //         item.product_name?.toLowerCase().includes(query.toLowerCase()) || 
  //         item.product_code?.toLowerCase().includes(query.toLowerCase()) 
  //       );
  //     });

  //     console.log("Filtered Results:", searchedOrders);
  //     setFilteredProducts(searchedOrders);
  //     setCurrentPage(1);
  // };
  const handleSearch = (e) => {
    const query = e.target.value;
    setSearchQuery(query);

    let filtered = products;

    // 🔹 Search
    if (query) {
      filtered = filtered.filter(item =>
        item.product_name?.toLowerCase().includes(query.toLowerCase()) ||
        item.product_code?.toLowerCase().includes(query.toLowerCase())
      );
    }

    // 🔹 Apply brand filter also
    if (selectedBrand) {
      filtered = filtered.filter(p => p.brand_name === selectedBrand);
    }

    setFilteredProducts(filtered);
    setCurrentPage(1);
  };



  return (
    <>
      <Header />
      <div class="page-wrapper compact-wrapper" id="pageWrapper">
        <div class="page-body-wrapper">
          <div className="page-body">
            <div className="container-fluid">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card card-table">
                    <div className="card-body">
                      <div className="title-header option-title d-sm-flex d-block">
                        <h5>List of Product</h5>
                        <div className="right-options">
                          <ul>
                            {/*   <li>
                              <Link
                                className="btn btn-solid"
                                to={`/subcategory/${category_id}`}
                              >
                                Back
                              </Link>
                            </li> */}

                            <li>
                              <Link
                                className="btn btn-solid"
                                to="/addproducts"
                              // state={{ category_id, subcategory_id }} // pass the id using state
                              >
                                Add Product
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div class="row" style={{ display: "flex", justifyContent: "space-between" }}>
                        <div className="col-sm-6 col-lg-3">
                          <form className="theme-form theme-form-2 mega-form">

                            <div className="mb-4 ">
                              <label htmlFor="search" className="form-label">
                                Search:
                              </label>

                              <input
                                type="text"
                                id="search"
                                name="search"
                                className="form-control"
                                placeholder="Search Products"
                                value={searchQuery}
                                onChange={handleSearch}
                              />
                            </div>

                          </form>
                        </div>

                        <div className="col-sm-3 col-lg-3">
                          <label className="form-label">Category:</label> {/* optional label */}

                          <select
                            className="form-control"
                            value={selectedCategory}
                            onChange={(e) => handleCategoryFilter(e.target.value)}
                          >
                            <option value="">All Category</option>
                            {categorie.map((category) => (
                              <option key={category.category_id} value={category.category_name}>
                                {category.category_name}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="col-sm-3 col-lg-3">
                          <label className="form-label">Brand:</label> {/* optional label */}

                          <select
                            className="form-control"
                            value={selectedBrand}
                            onChange={(e) => handleBrandFilter(e.target.value)}
                          >
                            <option value="">All Brands</option>
                            {/* {brands.map((brand) => ( */}
                            {filteredBrands.map((brand) => (
                              <option key={brand.brand_id} value={brand.brand_name}>
                                {brand.brand_name}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div class="col-sm-2 import-product-button">
                          <ul >
                            <li>
                              <Link
                                className="btn btn-solid"
                                to="/importproducts"
                              >
                                Import Product
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>

                      <form >
                        {loading ? (
                          <div
                            className="d-flex justify-content-center align-items-center"
                            style={{ height: "200px" }}
                          >
                            <div
                              className="spinner-border text-primary"
                              style={{ width: "3rem", height: "3rem" }}
                              role="status"
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                          </div>
                        ) : (
                          <>
                            <div className="table-responsive">
                              <table
                                className="table all-package theme-table table-product"
                                id="table_id"
                              >
                                <thead>
                                  <tr>
                                    <th>S.No.</th>
                                    {/*  <th style={{ textAlign: "center" }}>
                                      Images
                                    </th> */}
                                    <th>Code</th>
                                    <th>Product Name</th>
                                    <th>HSN Code</th>
                                    {/* <th>Sku No</th> */}
                                    <th>Tax (%)</th>
                                    <th style={{ textAlign: "center" }}>
                                      Price
                                    </th>
                                    {/* <th>Active</th> */}
                                    <th style={{ textAlign: "center" }}>
                                      Action
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {currentRecords.map((product, index) => (
                                    <tr key={product.id}>
                                      <td>{indexOfFirstRecord + index + 1}</td>
                                      <td>{product.product_code}</td>
                                      <td>{product.product_name}</td>
                                      <td>{product.hsn_code}</td>
                                      {/* <td style={{ textAlign: "center" }}>
                                        {product.sku_no}
                                      </td> */}
                                      <td style={{ textAlign: "center" }}>
                                        {product.tax}
                                      </td>
                                      <td style={{ textAlign: "center" }}>
                                        <i className="bi bi-currency-dollar"></i>{product.sell_price}
                                      </td>
                                      <td style={{ textAlign: "center" }}>
                                        <ul>
                                          <li>
                                            <Link
                                              to={`/editproducts/${product.product_id}`}
                                            // state={{
                                            //   category_id,
                                            //   subcategory_id,
                                            // }}
                                            >
                                              <i className="ri-pencil-line"></i>
                                            </Link>
                                          </li>
                                          <li>
                                            <a
                                              href="#"
                                              onClick={(e) => {
                                                e.preventDefault();
                                                openDeleteModal(
                                                  product.product_id
                                                );
                                              }}
                                            >
                                              <i className="ri-delete-bin-line"></i>
                                            </a>
                                          </li>
                                        </ul>
                                      </td>
                                    </tr>
                                  ))}

                                  <td colSpan="9">
                                    <table width="100%" border="1" style={{ borderCollapse: "collapse", border: "1px solid #000" }}>
                                      <tr>
                                        <td width="20%">Page {currentPage} of {totalPages}</td>
                                        <td style={{ textAlign: "right" }}>
                                          {/* Previous Button */}
                                          {currentPage > 1 ? (
                                            <a className="pagetext" href="javascript:void(0);" onClick={() => paginate(currentPage - 1)}>
                                              &laquo; Previous
                                            </a>
                                          ) : (
                                            <span>&laquo; Previous</span>
                                          )}
                                          &nbsp;
                                          {/* Page Numbers */}
                                          {[...Array(totalPages)].map((_, i) => (
                                            <React.Fragment key={i}>
                                              <a
                                                key={i}
                                                className={`pagetext ${currentPage === i + 1 ? "active" : ""}`}
                                                href="javascript:void(0);"
                                                onClick={() => paginate(i + 1)}
                                              >
                                                {i + 1}
                                              </a>
                                              &nbsp;
                                            </React.Fragment>
                                          ))}

                                          {/* Next Button */}
                                          {currentPage < totalPages ? (
                                            <a className="pagetext" href="javascript:void(0);" onClick={() => paginate(currentPage + 1)}>
                                              Next &raquo;
                                            </a>
                                          ) : (
                                            <span>Next &raquo;</span>
                                          )}

                                          {/* Last Button */}
                                          {currentPage < totalPages ? (
                                            <a className="pagetext" href="javascript:void(0);" onClick={() => paginate(totalPages)}>
                                              Last &raquo;&raquo;
                                            </a>
                                          ) : (
                                            <span>Last &raquo;&raquo;</span>
                                          )}
                                        </td>
                                      </tr>
                                    </table>
                                  </td>
                                </tbody>
                              </table>
                            </div>
                          </>
                        )}
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showModal && (
        <div className="modal fade show" style={{ display: "block" }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body">
                <h5>Confirm Delete</h5>
                <p>Are you sure you want to delete this product?</p>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closeModal}
                ></button>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={closeModal}
                >
                  No
                </button>
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={handleDelete}
                >
                  Yes, Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Products;
